import React, { memo, useEffect, useRef, useState } from "react";

import { Block, SelectionTaxonomyEntry, StringTaxonomyEntry, TaxonomyEntryType } from "../../types";
import { InputComponentProps } from "./common";
import { HighlightWithinTextarea } from 'react-highlight-within-textarea';

import './StringInput.scss'
import { extractHumanReadableText } from "../../Document/InnodomContent/util";
const myers = require('myers-diff');

const removeTrailingAndLeadingPunc = (string: string) : string =>  {
  if (!string) {
    return string;
  }
  
  const punctuations = [".", ",", ":", "!", "?", ";"];
  let start = 0;
  let end = string.length;
  for (let i = 0; i < end; i++) {
    if (punctuations.indexOf(string[i]) === -1) {
      break;
    }
    start = i + 1;
  }

  for (let i = end - 1; i >= 0; i--) {
    if (punctuations.indexOf(string[i]) === -1) {
      break;
    }
    end = i;
  }

  return string.substring(start, end);
}

interface StringInputComponentProps extends InputComponentProps<SelectionTaxonomyEntry | StringTaxonomyEntry, string> {
  block: Block;
}

const StringInputComponent = ({
  active,
  dataPoint,
  id,
  onFocus,
  onUpdate,
  value,
  block
}: StringInputComponentProps) => {
  const isSelection = dataPoint.type === TaxonomyEntryType.Selection;
  const focusRef = useRef<HTMLTextAreaElement>(null);
  const [highlights, setHighlights] = useState<Array>([]);

  useEffect(() => {
    if (!focusRef.current) {
      return;
    }
    if (active && focusRef.current.focus) {
      focusRef.current.focus();
    } else if (focusRef.current.blur) {
      focusRef.current.blur();
    }
  }, [active]);

  // Doesn't work very well due to weaknesses in the myers library.
  // Could be revised and improved later. 

  /*useEffect(() => {
    if (state) {
      const block = state.blocks[value.idRef as string];
      if (!block) {
        return;
      }
      let answerVal = value.value;
      let textVal = extractHumanReadableText(block.element);
      
      let answerValNoPunc = answerVal
        .split(" ")
        .map(x => removeTrailingAndLeadingPunc(x))
        .join(" ");

      let textValNoPunc = textVal
        .split(" ")
        .map(x => removeTrailingAndLeadingPunc(x))
        .join(" ");

      const realDiff = myers.diff(answerVal, textVal, {
        compare: 'words'
      });

      const noPuncDiff = myers.diff(answerValNoPunc, textValNoPunc, {
        compare: 'words'
      });

      // We can't just work off noPuncDiff because the indices have changed when we removed the punc
      const rangesWithDiffs = realDiff.map(x => {
        // TODO : this will not show when the Answer has extra punctuation,
        // this is hard because of tokenizing limitations of the lib
        // we'd need a custom implementation of myers to achieve this
        if (noPuncDiff.find(noPunc => 
          noPunc.lhs.text === removeTrailingAndLeadingPunc(x.lhs.text) && 
          (noPunc.lhs.add > 0 || noPunc.lhs.del > 0))) {
          return [x.lhs.pos, x.lhs.pos + x.lhs.length];
        } 
        return undefined;
      }).filter(x => !!x)
      console.log(realDiff);
      console.log(noPuncDiff);
      setHighlights(rangesWithDiffs);
    }

  }, [value.value]);*/

  useEffect(() => {
    if (block) {
      let textVal = extractHumanReadableText(block.element);
      if (textVal.indexOf(value.value) === -1) {
        setHighlights([0, value.value.length]);
      } else {
        setHighlights([]);
      }
    }

  }, [value.value, block]);

  return (
    <>
      <HighlightWithinTextarea
        autoComplete="off"
        id={id}
        ref={focusRef}
        maxLength={typeof dataPoint.maxLength === "number" ? dataPoint.maxLength : undefined}
        minLength={typeof dataPoint.minLength === "number" ? dataPoint.minLength : undefined}
        onChange={e => {
          // For some reason it sometimes fires on change when getting/losing focus.
          // We don't want this to fire an event or it will cause the point to get selected
          // for no reason
          if (e !== value.value) {
            onUpdate(id, e, e);
          }
        }}
        onFocus={() => {
          onFocus(id);
        }}
        readOnly={isSelection}// doesn't seem to work, instead disabling onChange above
        value={value.value}
        highlight={highlights}
        placeholder=""
      />
    </>
  );
};
StringInputComponent.displayName = "StringInput";
export const StringInput = memo(StringInputComponent);
